export { default } from './SelectAreaGroup';
